import React, { useState } from 'react';

import { Form } from 'antd';
import styled from 'styled-components';

import Checkbox from 'components/lib/Checkbox';
import { Divider } from 'components/lib/Divider';

import Input from '../../lib/Input';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0px;
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 20px;
  margin-top: 20px;
`;

const Label = styled.span`
  display: flex;
  font-family: var(--font-bold);
  font-size: 14px;
  justify-content: end;
  width: 75px;
  color: var(--text-primary);
`;

const Title = styled.div`
  font-family: var(--font-bold);
  font-size: 14px;
  margin-left: 10px;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  span {
    display: flex;
  }
`;

const IncentivesProposalModalProposalResident = () => {
  const [disabled, setDisabled] = useState(true);

  return (
    <Container>
      <LabelContainer>
        <Form.Item noStyle name={['resident', 'enabled']} valuePropName="checked">
          <Checkbox className={'green'} onChange={(event: any) => setDisabled(!event.target.checked)} />
        </Form.Item>
        <Title>Resident (if different than recipient)</Title>
      </LabelContainer>
      <Divider />
      <FormContainer>
        <Form.Item
          name={['resident', 'first_name']}
          label={<Label>First Name</Label>}
          rules={[{ required: !disabled, message: 'This field is required!' }]}
          style={{ height: 36 }}
        >
          <Input placeholder={"Enter the resident's first name"} disabled={disabled} />
        </Form.Item>
        <Form.Item
          name={['resident', 'last_name']}
          label={<Label>Last Name</Label>}
          rules={[{ required: !disabled, message: 'This field is required!' }]}
          style={{ height: 36 }}
        >
          <Input placeholder={"Enter the resident's last name"} disabled={disabled} />
        </Form.Item>
      </FormContainer>
    </Container>
  );
};

export default IncentivesProposalModalProposalResident;
